// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper-content[data-v-42b50536]{min-height:100%}.wrapper-content .details[data-v-42b50536]{width:100%;padding:30px 0}.wrapper-content .details .title[data-v-42b50536]{text-align:center;font-size:22px;color:#1e50ae;font-weight:700}.wrapper-content .details .date[data-v-42b50536]{text-align:center;font-size:14px;color:#666;margin:30px 0}.wrapper-content .details .ql-editor[data-v-42b50536]{line-height:34px;font-size:16px}", ""]);
// Exports
module.exports = exports;
